import Form from 'admin/components/RepeatingInvoice/Form'
import Flash from 'admin/components/shared/Flash'
import useDocument from 'admin/hooks/useDocument'
import useEffect from 'admin/hooks/useEffect'
import useRepeatingInvoice from 'admin/hooks/useRepeatingInvoice'
import useStateObject from 'admin/hooks/useStateObject'
import React, {Fragment} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import {NumberParam, useQueryParams} from 'use-query-params'
import useAccount from '../../hooks/useAccount'
import Header from '../shared/Header'
import {TAX_TYPES} from '../../lib/tax'

export default () => {
  const history = useHistory()
  const {organisationID} = useParams()
  const [{accountId}] = useQueryParams({accountId: NumberParam})
  const {account} = useAccount(organisationID, accountId)
  const {repeatingInvoice, errors, create} = useRepeatingInvoice(organisationID)
  const [form, setForm] = useStateObject({
    ...repeatingInvoice,
    taxType: TAX_TYPES.inclusive
  })

  useDocument({title: 'New repeating invoice'})

  useEffect(() => setForm(repeatingInvoice), [repeatingInvoice])
  useEffect(() => setForm({account, accountId}), [account])

  const handleCreate = e => {
    e.preventDefault()
    create(form, ({repeatingInvoice}) => {
      history.replace(`/orgs/${organisationID}/repeating_invoices/${repeatingInvoice.id}`)
    })
  }

  const breadcrumbs = []
  if (repeatingInvoice.account?.id || account?.id) {
    breadcrumbs.push({
      label: 'Manage accounts',
      path: `/orgs/${organisationID}/accounts`
    })
    breadcrumbs.push({
      label: repeatingInvoice.account?.displayName || account?.displayName,
      path: `/orgs/${organisationID}/accounts/${repeatingInvoice.account?.id || account?.id}`
    })
  } else {
    breadcrumbs.push({
      label: 'Repeating Invoices',
      path: `/orgs/${organisationID}/repeating_invoices`
    })
  }

  return (
    <Fragment>
      <Flash />

      <Header breadcrumbs={breadcrumbs} title='New repeating invoice'>
        <button className='button is-success' onClick={handleCreate}>
          Create
        </button>
      </Header>
      <section className='section'>
        <div className='container'>
          <Form errors={errors} organisationID={organisationID} repeatingInvoice={form} onChange={setForm} />
        </div>
      </section>
    </Fragment>
  )
}
